import * as React from 'react'

import * as previewable from '@owl-nest/previewable'
import * as model from '@owl-nest/models'
import * as api from '@owl-nest/api-client/latest'

import * as UFE from '../../UFE'

type ImpactBlockProps = {
  impact: model.impact.Impact
  lang?: api.Lang
}

export function ImpactBlock({ impact, lang }: ImpactBlockProps): React.ReactElement<ImpactBlockProps> {
  return <previewable.ImpactBlock impact={impact} lang={lang} sdgHelpUrl={UFE.LINKS.sdg} />
}
